export default {"src":"/_next/static/media/copy.889dd927.svg","height":16,"width":16};